import { render, staticRenderFns } from "./SolicitudDesarchivo.vue?vue&type=template&id=6b70dbe6&"
import script from "./SolicitudDesarchivo.vue?vue&type=script&lang=js&"
export * from "./SolicitudDesarchivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports